import type { DataTableFilterField } from "@/components/data-table/types";
import {
  COMMITMENTS,
  JOB_CATEGORIES,
  PRIORITIES,
  RATES,
  RESUME_REQUIRED,
  WORK_MODELS,
} from "@/config/constants";

export type MarketplaceFilterSchema = {
  compensation: number[];
  compensation_rate: string[];
  category: string[];
  work_model: string[];
  commitment: string[];
  priority: string[];
  resume: string[];
  posted_date: Date[];
};

export const marketplaceFilterFields: DataTableFilterField<MarketplaceFilterSchema>[] =
  [
    {
      label: "Compensation range",
      value: "compensation",
      type: "slider",
      leading: "R",
      min: 0,
      max: 10_000,
      defaultOpen: true,
    },
    {
      label: "Compensation rate",
      value: "compensation_rate",
      type: "checkbox",
      options: RATES,
    },
    {
      label: "Category",
      value: "category",
      type: "checkbox",
      options: JOB_CATEGORIES,
    },
    {
      label: "Work model",
      value: "work_model",
      type: "checkbox",
      options: WORK_MODELS,
    },
    {
      label: "Commitment",
      value: "commitment",
      type: "checkbox",
      options: COMMITMENTS,
    },
    {
      label: "Priority",
      value: "priority",
      type: "checkbox",
      options: PRIORITIES,
    },
    {
      label: "Resume required",
      value: "resume",
      type: "checkbox",
      options: RESUME_REQUIRED,
    },
    {
      label: "Posted date range",
      value: "posted_date",
      type: "timerange",
    },
  ];
